<template>
  <div class="row" v-if="statistics">
    <div class="col-lg-3">
      <v-statistics-card
        text="word.reviews"
        type="success"
        icon="check"
        :statistic="statistics.reviews_count"
      />
    </div>
    <div class="col-lg-3">
      <v-statistics-card
        text="word.login_attempts"
        type="secondary"
        icon="sign-in"
        :statistic="statistics.login_attempts_count"
      />
    </div>
    <div class="col-lg-3">
      <v-statistics-card
        text="word.ip_addresses"
        type="primary"
        icon="address-card"
        :statistic="statistics.ip_addresses_count"
      />
    </div>
    <div class="col-lg-3">
      <v-statistics-card
        text="phrase.users_with_same_ip"
        type="danger"
        icon="users"
        :statistic="statistics.other_users_count"
      />
    </div>
  </div>
</template>

<script>
import StatisticCard from '@/common/components/StatisticCard.vue';
import api from '@/common/api';

export default {
  name: 'UserStatisticsTable',
  components: {
    'v-statistics-card': StatisticCard,
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      statistics: null,
    };
  },
  methods: {
    async fetchUserStatistics() {
      const response = await api.get(`admin/users/${this.userId}/statistics`);
      this.statistics = response.data;
    },
  },
  created() {
    this.fetchUserStatistics();
  },
};
</script>
